import PropTypes from 'prop-types';
import {memo} from 'react';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import getDeliveryAddressAttribute from '../../delivery-address/getDeliveryAddressAttribute';
import Spacing from '../../style-helper/Spacing';
import doMetric from '../../tracking/bigQueryMetricRecorder';
import Track from '../../utils/tracking';

const useStyles = createUseStyles({
  addressRadioButton: {
    display: 'flex',
  },
  radioContainer: props => (props.hidden ? {
    position: 'absolute',
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    clipPath: 'inset(50%)',
  } : {
    marginRight: Spacing.single,
  }),
});

export function AddressRadioButton(props) {
  const classes = useStyles(props);
  
  const handleChange = () => {
    props.onChange(props);
    try {
      doMetric('selectDeliveryAddress', props.getDeliveryAddressAttribute());
    } catch (error) {
      Track.track(error);
    }
  };
  
  const checked = props.addressId === props.checkAgainst;
  return (
    <label className={classes.addressRadioButton} data-test="AddressRadioButton__label">
      <span className={classes.radioContainer}>
        <input
          disabled={props.disabled}
          id={props.id}
          type="radio"
          checked={checked}
          onChange={handleChange}
          name="storedAddress"
          value={props.addressId}
          data-country-code={props.country}
          data-county={props.county}
        />
      </span>
      {props.children}
    </label>
  );
}

AddressRadioButton.propTypes = {
  addressId: PropTypes.string.isRequired,
  checkAgainst: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  country: PropTypes.string.isRequired,
  county: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  getDeliveryAddressAttribute: PropTypes.func.isRequired,
};

export default memo(connect(null, {getDeliveryAddressAttribute})(AddressRadioButton));
